import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X, Globe } from "lucide-react";
import { LANGUAGES } from "../lib/constants";

const STORAGE_KEY = "cmr_lang_banner_dismissed";

export default function LanguageDetectBanner() {
  const { i18n } = useTranslation();
  const [suggest, setSuggest] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(STORAGE_KEY) === "1") return;

    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    const current = (i18n.language || "es").slice(0, 2).toLowerCase();
    const supported = LANGUAGES.map((l) => l.code);

    if (browser !== current && supported.includes(browser)) {
      const target = LANGUAGES.find((l) => l.code === browser);
      setSuggest(target);
    }
  }, [i18n.language]);

  if (!suggest) return null;

  const switchLang = () => {
    i18n.changeLanguage(suggest.code);
    localStorage.setItem(STORAGE_KEY, "1");
    setSuggest(null);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setSuggest(null);
  };

  const labels = {
    en: "Looks like you speak English — switch?",
    fr: "Vous parlez français — changer ?",
    de: "Sie sprechen Deutsch — wechseln?",
    it: "Parli italiano — cambiare?",
    zh: "看起来您说中文 — 要切换吗？",
    ru: "Похоже, вы говорите по-русски — переключить?",
    es: "¿Hablas español — cambiar?",
  };

  return (
    <div
      data-testid="lang-detect-banner"
      role="alert"
      className="fixed bottom-24 left-1/2 z-50 flex w-[min(420px,92vw)] -translate-x-1/2 items-center gap-3 border-2 border-brand-orange bg-brand-black px-4 py-3 text-white shadow-[0_18px_40px_rgba(0,0,0,0.55)]"
    >
      <Globe className="h-5 w-5 shrink-0 text-brand-orange" />
      <div className="flex-1 text-sm">
        <span className="mr-1">{suggest.flag}</span>
        <span>{labels[suggest.code] || `Switch to ${suggest.label}?`}</span>
      </div>
      <button
        data-testid="lang-banner-switch"
        onClick={switchLang}
        className="rounded-none border border-brand-orange bg-brand-orange px-3 py-1 text-xs font-bold uppercase tracking-widest text-white hover:bg-white hover:text-brand-orange"
      >
        {suggest.code.toUpperCase()}
      </button>
      <button
        data-testid="lang-banner-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-white/60 hover:text-white"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
